export default __webpack_public_path__ + "static/media/German Bionic Systems.8829381a.png";